import * as SystemActions from './../../system/actions/system.actions';
import * as PlannedPortfoliosActions from './../../planned-portfolios/actions/planned-portfolios.actions';
import { modelPortfolioAdapter } from './../selectors/model-portfolios.selectors';
import * as ModelPortfoliosActions from './../actions/model-portfolios.actions';
import * as ModelPortfolioSubscriptionActions from '../actions/model-portfolio-subscription.actions';
import { initialModelPortfoliosState, IModelPortfoliosState } from '../../state/model-portfolios.state';

export function ModelPortfoliosReducer(
  state = initialModelPortfoliosState,
  action: ModelPortfoliosActions.ModelPortfoliosActions |
    ModelPortfolioSubscriptionActions.ModelPortfolioSubscriptionActions |
    PlannedPortfoliosActions.PlannedPortfoliosActions |
    SystemActions.SystemActions)
  : IModelPortfoliosState {

  switch (action.type) {
    case ModelPortfoliosActions.ModelPortfoliosActionTypes.GET_MODEL_PORTFOLIOS_SUCCESS:
      const getModelPortfoliosSuccessState = {
        ...state,
        isInitialState: false
      };
      return modelPortfolioAdapter.upsertMany(action.payload, getModelPortfoliosSuccessState);
    case ModelPortfoliosActions.ModelPortfoliosActionTypes.MODEL_PORTFOLIOS_DATA_ERROR:
      return {
        ...state,
        loading: false,
        modelPortfolioDataError: {
          failText: action.payload
        }
      };
    case ModelPortfoliosActions.ModelPortfoliosActionTypes.SELECT_MODEL_PORTFOLIO:
      return {
        ...state,
        selectedModelPortfolioId: action.payload.id,
        isModelPortfolioUpdated: false,
        lastSavedModelPortfolio: {
          ...action.payload,
          positions: [...action.payload.positions]
        }
      };
    case ModelPortfoliosActions.ModelPortfoliosActionTypes.UPDATE_MODEL_PORTFOLIO_POSITIONS_STATE:
      const updateModelPortfolioPositionsState = {
        ...state,
        selectedModelPortfolioId: action.payload.id,
        isModelPortfolioUpdated: true,
        selectedModelPortfolio: action.payload
      };
      return modelPortfolioAdapter.upsertOne(action.payload, updateModelPortfolioPositionsState);
    case ModelPortfoliosActions.ModelPortfoliosActionTypes.DELETE_MODEL_PORTFOLIO_POSITION:
      const deleteModelPortfolioPositionState = {
        ...state,
        selectedModelPortfolioId: action.payload.modelPortfolio.id,
        modelPortfolioPositionDeletedSuccess: true,
        isModelPortfolioUpdated: true,
        modelPortfolioPositionDeletedSuccessText: `Success! The security ${action.payload.positionName} has been removed.`,
        selectedModelPortfolio: action.payload.modelPortfolio
      };
      return modelPortfolioAdapter.upsertOne(action.payload.modelPortfolio, deleteModelPortfolioPositionState);
    case ModelPortfoliosActions.ModelPortfoliosActionTypes.DELETE_MODEL_PORTFOLIO_POSITION_RESET:
      return {
        ...state,
        modelPortfolioPositionDeletedSuccess: false
      };
    case ModelPortfoliosActions.ModelPortfoliosActionTypes.RESET_SELECTED_MODEL_PORTFOLIO:
      const resetSelectedModelPortfolioState = {
        ...state,
        isModelPortfolioUpdated: false
      };
      return modelPortfolioAdapter.upsertOne(action.payload, resetSelectedModelPortfolioState);
    case ModelPortfoliosActions.ModelPortfoliosActionTypes.MODEL_PORTFOLIO_DATA_ERROR:
      return {
        ...state,
        loading: false,
        modelPortfolioSubmittedSuccess: false,
        modelPortfolioSubmittedFail: true,
        modelPortfolioDataError: {
          failText: action.payload
        }
      };
    case ModelPortfoliosActions.ModelPortfoliosActionTypes.SUBMIT_MODEL_PORTFOLIO:
    case ModelPortfoliosActions.ModelPortfoliosActionTypes.DELETE_MODEL_PORTFOLIO_SUBSCRIPTION:
      return {
        ...state,
        loading: true,
        modelPortfolioSubmittedSuccess: false,
        modelPortfolioSubmittedFail: false,
        isModelPortfolioSubmitted: true,
        submittedModelPortfolio: action.payload,
        modelPortfolioDataError: null
      };
    case ModelPortfoliosActions.ModelPortfoliosActionTypes.SUBMIT_MODEL_PORTFOLIO_SUCCESS:
      return {
        ...state,
        loading: false,
        modelPortfolioSubmittedSuccess: true,
        modelPortfolioSubmittedFail: false,
        lastSavedModelPortfolio: {
          ...action.payload,
          positions: [...action.payload.positions]
        },
        lastSubmittedModelPortfolioId: action.payload.id,
        isModelPortfolioUpdated: false,
        failedTempPlannedPortfolios: action.payload.failedRebalancedPortfolios,
      };
    case ModelPortfoliosActions.ModelPortfoliosActionTypes.RESET_SUBMIT_MODEL_PORTFOLIO:
      return {
        ...state,
        loading: false,
        modelPortfolioSubmittedSuccess: false,
        modelPortfolioSubmittedFail: false,
        submittedModelPortfolio: null,
        modelPortfolioDataError: null
      };
    case ModelPortfoliosActions.ModelPortfoliosActionTypes.SELECT_MODEL_PORTFOLIO_POSITION:
      return {
        ...state,
        selectedModelPortfolioPosition: action.payload,
        isModelPortfolioSubmitted: false
      };
    case ModelPortfoliosActions.ModelPortfoliosActionTypes.APPLY_MODEL_PORTFOLIO_SUCCESS:
      return {
        ...state,
        loading: false,
        rebalancedPlannedPortfolios: action.payload.rebalancedPlannedPortfolios,
        failedTempPlannedPortfolios: action.payload.failedTempPlannedPortfolios,
        modelPortfolioSubmittedSuccess: true
      };
    case PlannedPortfoliosActions.PlannedPortfoliosActionTypes.SELECT_TEMP_PLANNED_PORTFOLIO:
    case PlannedPortfoliosActions.PlannedPortfoliosActionTypes.SELECT_PLANNED_PORTFOLIO:
      return {
        ...state,
        loading: true
      };
    case PlannedPortfoliosActions.PlannedPortfoliosActionTypes.SELECT_TEMP_PLANNED_PORTFOLIO_FAIL:
    case PlannedPortfoliosActions.PlannedPortfoliosActionTypes.SELECT_PLANNED_PORTFOLIO_FAIL:
      return {
        ...state,
        loading: false,
        rebalancedPlannedPortfolios: action.payload.rebalancedPlannedPortfolios,
        failedTempPlannedPortfolios: action.payload.failedTempPlannedPortfolios
      };
    case PlannedPortfoliosActions.PlannedPortfoliosActionTypes.SELECT_TEMP_PLANNED_PORTFOLIO_SUCCESS:
    case PlannedPortfoliosActions.PlannedPortfoliosActionTypes.SELECT_PLANNED_PORTFOLIO_SUCCESS:
      return {
        ...state,
        loading: false,
        rebalancedPlannedPortfolios: action.payload.rebalancedPlannedPortfolios,
        failedTempPlannedPortfolios: action.payload.failedTempPlannedPortfolios
      };
    case ModelPortfoliosActions.ModelPortfoliosActionTypes.DELETE_MODEL_PORTFOLIO:
      const deletedModelPortfolioState = {
        ...state,
        loading: true,
        modelPortfolioDeletedSuccess: false
      };
      return modelPortfolioAdapter.removeOne(action.payload.modelPortfolioId, deletedModelPortfolioState);
    case ModelPortfoliosActions.ModelPortfoliosActionTypes.DELETE_MODEL_PORTFOLIO_SUCCESS:
      return {
        ...state,
        loading: false,
        modelPortfolioDeletedSuccess: true,
        modelPortfolioDeletedSuccessText: action.payload
      };
    case ModelPortfoliosActions.ModelPortfoliosActionTypes.RESET_DELETE_MODEL_PORTFOLIO:
      return {
        ...state,
        loading: false,
        modelPortfolioDeletedSuccess: false
      };
    case SystemActions.CLEAR_SYSTEM:
      return initialModelPortfoliosState;
    default:
      return state;
  }
}

